"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDateValueFormatter = void 0;
// (C) 2020 GoodData Corporation
var dateValueParser_1 = require("./dateValueParser");
/**
 * Creates a function that takes a string date attribute value and a targetDateFormat and returns a formatted date string in the target date format.
 * @param dateFormatter - function to use to format Date values to a string
 * @public
 */
function createDateValueFormatter(dateFormatter) {
    return function (value) { return dateFormatter(dateValueParser_1.parseDateValue(value)); };
}
exports.createDateValueFormatter = createDateValueFormatter;
//# sourceMappingURL=dateValueFormatter.js.map